import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "head-card" }

import { ref, reactive, onMounted, onUnmounted, watch } from 'vue'
import { typeList } from '@/config';
import store from '@/store';

export default /*@__PURE__*/_defineComponent({
  __name: 'HeadCard',
  props: {
    activeSolutionIndex: {
        default: 0,
        type: Number
    }
},
  setup(__props) {

const props = __props

const handleEvent = () => {
    let contactUsTop: any = store.state.contactUsTop;
    contactUsTop = {
        top: 166 + 'rem'
    }
    store.state.contactUsTop = JSON.parse(JSON.stringify(contactUsTop))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, _toDisplayString(_unref(typeList)[__props.activeSolutionIndex]?.header), 1),
    _createElementVNode("main", null, _toDisplayString(_unref(typeList)[__props.activeSolutionIndex]?.content), 1),
    _createElementVNode("div", {
      class: "btn",
      onClick: handleEvent
    }, "合作咨询")
  ]))
}
}

})